import SolarCalculator from "@/components/SolarCalculator";
import AffiliateDisclosure from "@/components/AffiliateDisclosure";

export default function SolarPanelCalculator() {
  return (
    <div className="py-12 lg:py-20 pb-28 lg:pb-20">
      <div className="max-w-4xl mx-auto px-4">
        <nav className="text-sm font-mono text-muted-foreground mb-6">
          <a href="/" className="hover:text-accent">Home</a>
          <span className="mx-2">/</span>
          <span>Solar Panel Calculator</span>
        </nav>

        <h1 className="font-heading font-bold text-4xl lg:text-5xl mb-4">
          Solar Panel Sizing Calculator
        </h1>
        <p className="text-lg text-muted-foreground mb-8 max-w-2xl">
          Use this interactive tool to estimate how many watts of solar panels you need for your 
          RV, camping setup, cabin, solar generator, or off-grid power system.
        </p>

        <AffiliateDisclosure />
        <SolarCalculator compact />

        <div className="mt-12 space-y-6 text-muted-foreground">
          <h2 className="font-heading font-bold text-2xl text-foreground">How to Use This Calculator</h2>
          <p>
            Start by selecting a preset that matches your use case, or enter your own daily watt-hour consumption. 
            Adjust the sun hours based on your location — most of the US gets 4–6 peak sun hours per day.
          </p>
          <p>
            The efficiency loss slider accounts for real-world factors like temperature, wiring losses, shading, 
            and panel degradation. A 20% loss is a reasonable default for most setups.
          </p>
          <p>
            The calculator provides a recommended total solar wattage and suggests a panel configuration. 
            Use these numbers as a starting point, then explore our comparison guides to find the specific 
            panels that match your needs and budget.
          </p>
        </div>
      </div>
    </div>
  );
}